import extend from "extend";

import { IEnvConfig, IEnvironment } from "./types";
import defaultConfig from "./env/default";

export let env: IEnvironment;
try {
    env = process.env as IEnvironment;
} catch (error) {
    env = {};
}

let envConfig: IEnvConfig = {};
// tslint:disable-next-line: no-var-requires
if (env.REACT_APP_ENV) envConfig = require(`./env/${env.REACT_APP_ENV}`).default as IEnvConfig;
// tslint:disable-next-line: no-var-requires
else envConfig = require(`./env/development`).default as IEnvConfig;
export const config = extend(true, defaultConfig, envConfig);
